import { addDays } from "../../cpcoc/addDays";
import { addMonths } from "../../cpcoc/addMonths";
import { getDates } from "./dates";
import { getReadingViewType } from "./setReadingViewType";
export function setPageDate(direction = "next", adjust = 1) {
    const dates = getDates();
    const newDate = dates.active;
    if (getReadingViewType() === "month") {
        dates[direction] = addMonths(newDate, 1 * adjust);
    }
    else {
        dates[direction] = addDays(newDate, 7 * adjust);
    }
    return dates.previous;
}
